import React from "react";
import { Link } from "react-router-dom";
import hshape from "../assets/img/hshape.svg";
import CategoryCard from "./CategoryCard.js";
const CategorySection = () => {
    return (
        <section className="section-space">
            <div className="container-xl">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <div className="main-h">
                            <h2 className="m-heading">Explore Course By Category</h2>
                            <img src={hshape} className='img-fluid ' alt="logo" />
                        </div>
                    </div>
                </div>
                <div className="row">
                <CategoryCard />
                </div>
            </div>
        </section>
    );
};

export default CategorySection;